import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { UPDATE_VERIFY_IDENTITY_STEP } from "./gql";
import Sentry from "../../../api/sentry";

import { GENERIC_ERROR_MESSAGE, ONBOARDING_STEPS , GQL_ERROR } from "../../../constants";

/* Actions */
import { updateToNextStep } from "../../../state/actions";
import { useCurrentStep } from "../../../state/store/customHooks";

import { Title } from "../../common";
import Loading from "../../common/Loading";
import VerifyIdentityForm from "./VerifyIdentityForm";

const VerifyIdentityV2 = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [errorNetwork, setErrorNetwork] = useState(null);

  const currentStep = useCurrentStep();
  const readOnlyMode = currentStep !== ONBOARDING_STEPS.Identity;

  const [updateIdentityStep, { loading: updateIdentityStepLoading }]
    = useMutation(UPDATE_VERIFY_IDENTITY_STEP);
  const _completeStep = async (ssn, dob) => {
    if (readOnlyMode) {
      setErrorNetwork(null);
      dispatch(updateToNextStep(history));
      return;
    }

    let data;
    try {
      data = await updateIdentityStep({
        variables: {
          userSSN: ssn,
          userDOB: dob,
        },
      });

    } catch (err) {
      Sentry.captureException(err);
      setErrorNetwork(GENERIC_ERROR_MESSAGE);
      return;
    }

    // TODO: typo here. "verify" is spelled wrong in the backend so now we have to extract
    // it like this
    const { updateVerifiyIdentityStep } = data.data;
    const { status } = updateVerifiyIdentityStep;

    if(status === GQL_ERROR){
      setErrorNetwork(GENERIC_ERROR_MESSAGE);
      return;
    }

    setErrorNetwork(null);
    dispatch(updateToNextStep(history));
  };

  return (
    <>
      { updateIdentityStepLoading && <Loading /> }
      <div className="outerStack-mobile sm:outerStack">
        <div className="innerStack">
          <Title text={"Let's verify your identity"} />
          <VerifyIdentityForm readOnly={readOnlyMode} _completeStep={_completeStep} />
          { errorNetwork && <div className="errorText">{errorNetwork}</div>}
          <div className='textContainer w-10/12 md:w-10/12'>
            <span className='text-xs'>
              This does not affect your credit score.
            </span>
          </div>
          <div className='w-10/12 md:w-8/12 leading-1 pt-1 m-auto leading-4' >
            <span className='text-xs'>
              We ask for this information to comply with financial regulations
              and confirm your identity. Your information is encrypted with
              bank-level security and is never stored by us.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyIdentityV2;